export default __webpack_public_path__ + "static/media/salon_back.4662da3f.jpg";